import { css, Theme } from "@emotion/react";
import { topMargin } from "@hl/communities-app/lib/styles/global/layout";

export const rowStyles = css`
  display: flex;
  flex-direction: column;
`;

export const copyContainerStyles = css`
  display: flex;
  ${topMargin("4/8px")}
`;

export const shareStyles = (theme: Theme) => css`
  margin-left: auto;
  font-size: ${theme.text.sizes.small};
  display: flex;
  flex-direction: row;
  gap: 6px;
`;
